import { GetterTree } from 'vuex'
import RoleState, {IRoleList} from './states'
import { State } from '@/store/store'
import _ from 'lodash'

const getters: GetterTree<RoleState, State> = {
  headerLists: (state) => {
    return state.list.column
  },
  itemLists: (state) => {
    return state.list.data
  },
  roleLists: (state) => {
    return state.list.data
  },
  roleById: (state) => {
    return _.mapKeys(state.list.data, '_id')
  },
  filterLists: (state) => {
    return state.list.defaultFilter
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
  roleUserList: (state) => {
    return state.roleUserList
  },
  rolePermissionList: (state) => {
    return state.rolePermissionList
  },
}

export default getters
